import React from 'react'

interface CustomDotsProps {
  activeIndex: number
  onClick:
    | ((slideNumber: number, dontAnimate?: boolean | undefined) => void)
    | undefined
  length: number
  autoplaySpeed?: number
  autoplay: boolean
}

const CustomDots = ({
  activeIndex,
  onClick,
  length,
  autoplaySpeed,
  autoplay,
}: CustomDotsProps) => {
  const numSlides = length

  const style =
    autoplay && autoplaySpeed
      ? {
          animationDuration: `${autoplaySpeed}ms`,
        }
      : {}

  const renderDots = () => {
    const dots = []

    for (let i = 0; i < numSlides; i++) {
      const isActive = i === activeIndex

      dots.push(
        <li>
          <div
            className={`custom-dot ${isActive ? 'slick-active' : ''}`}
            style={style}
          >
            <button
              key={i}
              onClick={() => onClick?.(i)}
              aria-label="custom-dot"
            />
          </div>
        </li>
      )
    }

    return dots
  }

  return <ul className="slick-dots">{renderDots()}</ul>
}

export default CustomDots
